import { Component, Input, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { MatChipInputEvent, MatChipGrid, MatChipOption, MatChipRemove, MatChipInput } from '@angular/material/chips';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatFormField, MatLabel } from '@angular/material/select';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'importer-chip-input',
  templateUrl: './chip-input.component.html',
  styleUrls: ['./chip-input.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatFormField, MatLabel, MatChipGrid, MatChipOption, MatIcon, MatChipRemove, MatChipInput]
})
export class ChipInputComponent {
  @Input() loading: boolean = false;
  @Input() disabled: boolean = false;
  @Input() label: string = 'Chip';
  @Input() chips: string[] = [];
  @Input() placeholder: string = 'New chip...';
  @Input() regExp: RegExp;

  addOnBlur = true;
  readonly separatorKeysCodes = [ENTER, COMMA] as const;

  constructor() {}

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  add(event: MatChipInputEvent): void {
    if (event.value) {
      if (!this.regExp || this.regExp.test(event.value)) {
        this.chips.push(event.value);
      }
      event.chipInput!.clear();
    }
  }

  remove(chip: string): void {
    const index = this.chips.indexOf(chip);

    if (index >= 0) {
      this.chips.splice(index, 1);
    }
  }

  resetFlags(): void {
    this.loading = false;
  }
}
